import { Reducer } from 'redux';
import { DictionaryActionTypes, DictionaryState } from './type';

const initialState: DictionaryState = {
  MEDICINEFREQ: [],  // 用药频率
  MEDICINEFREQ_OBJ: {},
  CERTTYPE: [],  // 证件类型
  CERTTYPE_OBJ: {},
  SOCIALSECURITYTYPE: [], // 社保类型
  SOCIALSECURITYTYPE_OBJ: {},
  GENDER: [],// 性别
  GENDER_OBJ: {},
  PATIENTRELATION: [],// 患者关系
  PATIENTRELATION_OBJ: {},
  MARRIAGE: [], // 婚姻状况
  MARRIAGE_OBJ: {},
  BLOODGROUP: [], // 血型
  BLOODGROUP_OBJ: {},
  PATIENTTYPE: [], // 患者类型
  PATIENTTYPE_OBJ: {},
  PROFESSIONALTITLE: [],  // 医生职级
  PROFESSIONALTITLE_OBJ: {},
  INQUIRYTYPE: [], // 问诊类型
  INQUIRYTYPE_OBJ: {},
  RANGETIMETYPE: [], // 血糖测量时间
  RANGETIMETYPE_OBJ: {},
  EXPRESSSTATUS: [], // 快递状态
  EXPRESSSTATUS_OBJ: {},
  DRUGTYPE: [], // 药品类型
  DRUGTYPE_OBJ: {},
  FAVOURTYPE: [], // 服务包详情的优惠类型
  FAVOURTYPE_OBJ: {},
  COUPONUSESCOPE: [],// 优惠券类型
  COUPONUSESCOPE_OBJ: {},
  POLICYVASENUM: [], // 服务卡名称
  POLICYVASENUM_OBJ: {},
  COUPONTYPE:[], // 优惠劵类型
  COUPONTYPE_OBJ:{},
  HEALTHCHECKSTATUSENUM: [], // 体检卡状态
  HEALTHCHECKSTATUSENUM_OBJ: {},
  WORKSTATUSENUM: [], // 医生工作状态
  WORKSTATUSENUM_OBJ: {},
  QUESTIONNAIRERESULTLEVELENUM: [],  // 测试列表安全等级
  QUESTIONNAIRERESULTLEVELENUM_OBJ:{},
  PROFESSIONALTITLEPHARMACIST: [],  // 药师职务
  PROFESSIONALTITLEPHARMACIST_OBJ:{},
  MEDICALORGANIZATIONLEVELENUM: [], // 医院等级
  MEDICALORGANIZATIONLEVELENUM_OBJ: {},
  MEDICALORGANIZATIONRANKAREAENUM: [], // 医院地区枚举
  MEDICALORGANIZATIONRANKAREAENUM_OBJ: {},
  MEDICALORGANIZATIONDEPARTMENTENUM: [], // 医院科室枚举
  MEDICALORGANIZATIONDEPARTMENTENUM_OBJ: {},
  SYSTEMMODE:[],// 监管模式
  SYSTEMMODE_OBJ:{},
  PUSHCOMMODITYCHANNEL:[],
  RIGHTSAPPLYCODEENUM: [],
  RIGHTSAPPLYCODEENUM_OBJ: {},
  RIGHTSAPPLYATTACHMENTENUM: [],
  RIGHTSAPPLYATTACHMENTENUM_OBJ: {},
};

const reducer: Reducer<DictionaryState> = (state = initialState, action) => {
  switch (action.type) {
  case DictionaryActionTypes.FETCH_DICTIONARY_LIST_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      ...data,
    };
  }
  default: {
    return state;
  }
  }
};

export { reducer as DictionaryReducer };
